import { captureMessage } from '@sentry/react';
import config from 'config/config';
import { BusinessChoiceType } from 'features/utils/types';
import { useSelector } from 'react-redux';
import { BusinessChoiceSelector } from 'store/selectors';

function getConsumptionConfigFromBusinessChoice(
  businessChoice: BusinessChoiceType | undefined
) {
  if (!businessChoice) {
    console.warn(
      'useConsumptionConfig | No business choice selected. Taking b2c'
    );
    captureMessage(
      'useConsumptionConfig | No business choice selected. Taking b2c'
    );
    return config.options.consumption.b2c;
  }
  return config.options.consumption[businessChoice];
}

export default function useConsumptionConfig() {
  const businessChoice = useSelector(BusinessChoiceSelector);

  return getConsumptionConfigFromBusinessChoice(businessChoice);
}
